import { ENUMS } from '@rapyd/use-hcp-preview';
import {
  UPDATE_DEMO_CARD_DETAILS,
  UPDATE_DEMO_MENU,
  UPDATE_DEMO_PREVIEW_PARAMS
} from 'redux/constants/demo';
import { CHECKOUT_DEMO_DEFAULT_COLORS } from 'consts/demo';
import {
  MANDATORY_CARD_FIELDS,
  PreviewParamKeys,
  CheckoutPagePreviewParamKeys,
  CHECKOUT_CATEGORIES_LIST,
  CDN_IMAGES_URL
} from 'consts';

enum StateKeys {
  checkout = 'checkout'
}

const initialState = {
  checkout: {
    previewParams: {
      [PreviewParamKeys.alias]: '',
      [PreviewParamKeys.btnColor]: '',
      [PreviewParamKeys.categories]: CHECKOUT_CATEGORIES_LIST,
      [PreviewParamKeys.ctaText]: 'pay',
      [PreviewParamKeys.language]: 'en-US',
      [PreviewParamKeys.logo]: '',
      [PreviewParamKeys.previewApplePay]: true,
      [PreviewParamKeys.previewGooglePay]: true,
      [PreviewParamKeys.reusablePage]: {},
      [PreviewParamKeys.buttonColor]: '',
      [PreviewParamKeys.pageType]: ENUMS.FEATURE_TYPES.Checkout,
      [PreviewParamKeys.view]: ENUMS.VIEWS.Desktop,
      [PreviewParamKeys.env]: ENUMS.ENVS.sandbox,
      [PreviewParamKeys.checkoutPage]: {
        [CheckoutPagePreviewParamKeys.calculated_payment_fees]: {},
        [CheckoutPagePreviewParamKeys.cart_items]: [
          {
            amount: 19,
            image: `${CDN_IMAGES_URL}/yoga_bottle.jpg`,
            name: 'Yoga Bottle',
            quantity: 1
          },
          {
            amount: 30,
            image: `${CDN_IMAGES_URL}/yoga_mat.jpg`,
            name: 'Yoga Mat',
            quantity: 1
          }
        ],
        [CheckoutPagePreviewParamKeys.payment_fx_metadata]: {
          amount: 49,
          country_code: 'GB',
          currency_code: 'EUR'
        },
        isDirty: false
      }
    },
    form: {
      colors: CHECKOUT_DEMO_DEFAULT_COLORS,
      showCartItems: true,
      showBillingAddress: false,
      showFx: false,
      showTaxesAndFees: false,
      displayMobileMenu: false,
      displayColorPicker: false,
      availableCategories: [] as ENUMS.CHECKOUT_CATEGORIES[],
      categoriesLoading: true,
      ctaTextsLoading: true,
      ctaTexts: [] as ENUMS.CTA_TEXTS[],
      selectedCategories: [] as ENUMS.CHECKOUT_CATEGORIES[]
    },
    cardDetails: {
      [MANDATORY_CARD_FIELDS.number]: '',
      [MANDATORY_CARD_FIELDS.cvv]: '',
      [MANDATORY_CARD_FIELDS.expiration]: '',
      [MANDATORY_CARD_FIELDS.cardholder]: ''
    }
  }
};

export type IDemoStore = typeof initialState;

const reducer = (state = initialState, action: Record<string, any>) => {
  const { data } = action?.payload || {};

  switch (action.type) {
    case UPDATE_DEMO_PREVIEW_PARAMS:
      return {
        ...state,
        [StateKeys.checkout]: {
          ...state[StateKeys.checkout],
          previewParams: {
            ...state[StateKeys.checkout].previewParams,
            ...data
          }
        }
      };
    case UPDATE_DEMO_MENU:
      return {
        ...state,
        [StateKeys.checkout]: {
          ...state[StateKeys.checkout],
          form: {
            ...state[StateKeys.checkout].form,
            ...data
          }
        }
      };
    case UPDATE_DEMO_CARD_DETAILS:
      return {
        ...state,
        [StateKeys.checkout]: {
          ...state[StateKeys.checkout],
          cardDetails: {
            ...state[StateKeys.checkout].cardDetails,
            ...data
          }
        }
      };
    default:
      return state;
  }
};

export default reducer;
